import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import {
  ICompleteSprintBody,
  IDashboardDetails,
  ISprintDetails,
  IUnResolvedTicket,
} from "../types";
import { initialState } from "./initialState";
import { set } from "lodash";
import { updateFiledType } from "../../types";

const useSprintSlice = createSlice({
  name: "sprintDetailsState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },

    setUnresolvedTicket: (
      state,
      action: PayloadAction<Array<IUnResolvedTicket>>,
    ) => {
      state.unResolvedTicketList = action.payload;
    },
    // sprint details
    setTicketListLoading: (state, action: PayloadAction<boolean>) => {
      state.UnresolvedLoading = action.payload;
    },
    fetchSprintDetails: (state, action: PayloadAction<string>) => {
      state.loading = true;
    }, // fetch sprint details API
    setSprintDetails: (state, action: PayloadAction<ISprintDetails>) => {
      state.sprintDetails = action.payload;
    },
    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>,
    ) => {
      set(state, `sprintDetails.${action.payload.key}`, action.payload.value);
    },
    updateMemberValueLocally: (
      state,
      action: PayloadAction<{ actions: "add" | "remove"; id: string }>,
    ) => {
      const { id, actions } = action.payload;

      // Ensure members array exists
      if (!state.sprintDetails.members) {
        state.sprintDetails.members = [];
      }
      if (actions === "add") {
        // Add only if not already present
        if (!state.sprintDetails.members.includes(id)) {
          state.sprintDetails.members.push(id);
        }
      } else if (actions === "remove") {
        // Remove by filtering out the id
        state.sprintDetails.members = state.sprintDetails.members.filter(
          (memberId: string) => memberId !== id,
        );
      }
    },

    updateSprint: (
      state,
      action: PayloadAction<{
        fieldUpdate: updateFiledType;
        id: string;
        callback: () => void;
      }>,
    ) => {
      state.buttonLoading = true;
    },

    fetchUnresolvedTicketList: (state, action: PayloadAction<string>) => {},

    // launch sprint
    toggleLaunchSprintWrapper: (state, action: PayloadAction<boolean>) => {
      state.LaunchSprintWrapper = action.payload;
    },
    toggleCompleteSprintDeleteWrapper: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.completeSprintDeleteWrapper = action.payload;
    },
    toggleCompleteSprintWrapper: (state, action: PayloadAction<boolean>) => {
      state.completeSprintWrapper = action.payload;
    },
    toggleNotStartedSprintDeleteWrapper: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.notStartedSprintDeleteWrapper = action.payload;
    },
    toggleBurndownChartWrapper: (state, action: PayloadAction<boolean>) => {
      state.burndownChartWrapper = action.payload;
    },
    toggleEffortsByAssigneesChartWrapper: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.effortsByAssigneesChartWrapper = action.payload;
    },

    launchSprint: (
      state,
      action: PayloadAction<{
        sprintId: string;
        callback: () => void;
      }>,
    ) => {},
    completeSprint: (
      state,
      action: PayloadAction<{
        sprintId: string;
        body: ICompleteSprintBody;
        callback: () => void;
      }>,
    ) => {},
    deleteSprint: (
      state,
      action: PayloadAction<{
        sprintId: string;
        body?: ICompleteSprintBody;
        callback: () => void;
      }>,
    ) => {},

    /// dashboard section reducer
    setDashboardLoading: (state, action: PayloadAction<boolean>) => {
      state.dashboardLoading = action.payload;
    },
    setDashboardDetails: (state, action: PayloadAction<IDashboardDetails>) => {
      state.dashboardDetails = action.payload;
    },
    fetchDashboardDetails: (state, action: PayloadAction<string>) => {
      state.dashboardLoading = true;
    },
  },
});

export const {
  reducer: sprintDetailsReducer,
  actions: sprintDetailsActions,
  name: sprintDetailsSliceKey,
} = useSprintSlice;
